var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(-1177.75 -624.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 24,
    height: 24,
    transform: "translate(1177.75 624.25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sms",
    transform: "translate(1177.75 624.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M7,21.25c-3.65,0-5.75-2.1-5.75-5.75v-7c0-3.65,2.1-5.75,5.75-5.75H17c3.65,0,5.75,2.1,5.75,5.75v7c0,3.65-2.1,5.75-5.75,5.75ZM2.75,8.5v7c0,2.86,1.39,4.25,4.25,4.25H17c2.86,0,4.25-1.39,4.25-4.25v-7c0-2.86-1.39-4.25-4.25-4.25H7C4.14,4.25,2.75,5.64,2.75,8.5Z",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M9.659,12.08l-3.13-2.5a.747.747,0,1,1,.93-1.17l3.13,2.5a2.386,2.386,0,0,0,2.81,0l3.13-2.5a.747.747,0,1,1,.93,1.17l-3.13,2.5a3.67,3.67,0,0,1-2.33.79A3.717,3.717,0,0,1,9.659,12.08Z",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.91fc5577ba750455d808f1fa3ef51c5b.svg";
export { ForwardRef as ReactComponent };